import { Component, EventEmitter, Input, Output, Signal } from '@angular/core';

@Component({
    selector: 'app-container-visibility-window',
    templateUrl: './container-visibility-window.component.html',
    styleUrls: ['./container-visibility-window.component.css']
})
export class ContainerVisibilityWindowComponent {
    @Input('floorContainerList') floorContainerList: Signal<any[]>;
    @Output() fileSelected: EventEmitter<any> = new EventEmitter<any>();
    @Output() backgroundToggled: EventEmitter<any> = new EventEmitter<any>();
    @Output() classContainerToggled: EventEmitter<any> = new EventEmitter<any>();

    onFileSelected(event, floorContainer) {
        this.fileSelected.emit({ event: event, floorContainer: floorContainer });
    }

    toggleBackgroundImageContainer(floorContainer) {
        this.backgroundToggled.emit(floorContainer);
    }

    toggleClassContainer(floorContainer) {
        this.classContainerToggled.emit(floorContainer);
    }

    opacityChanged(value, floorContainer) {
        floorContainer.editorObject.opacity(value);
    }

    formatLabel(value: number): string {
        return `${value}`;
    }
}